import React from 'react';
import { Col, NavbarBrand } from 'reactstrap';
import { T } from '../../traks';
import { Input } from '../../c/Input';
import { LL } from '../../c/LL';

const RememberForgot = ({ setUser, user, setForgotPw }) => {
	return (
		<div
			className="d-flex flex-row wrap justify-content-between my-3 font_11px cursor_pointer"
			style={{ marginLeft: "10px" }}
		>
			<div className="me-4" onClick={() => setUser({ ...user, rememberMe: !user.rememberMe })}>
				<input
					type="checkbox"
					style={{ transform: "scale(1.8)" }}
					className="primary me-3 cursor_pointer"
          id={"forgotCheckbox"}
					checked={user.rememberMe}
					onChange={() => setUser({ ...user, rememberMe: !user.rememberMe })}
				/>
				<span style={{ paddingTop: "5px" }}><T>Remember me</T></span>
			</div>
			<div className="cursor_pointer primary" onClick={() => setForgotPw(true)} >
				<T>Forgot password?</T>
			</div>
		</div>
	)
}

const Login = ({ user, setUser, handleLogin, setForgotPw }) => {
	const submit_button_disabled = !(
		user.username.length && user.password.length
	);


	return (
		<div className="d-flex flex-column justify-content-md-between w-100 vh-100">
			<div className="pt-3 pt-lg-5 mb-md-0 mb-5">
				<NavbarBrand href={LL("/")}>
					<img src='https://static.sibilus.eu/gfx/pentus-logo-0.svg' width="120px" alt='our logo' />
				</NavbarBrand>
			</div>
			<Col xs={12} lg={6} className="mx-auto mt-5 mt-md-0">
				<div className="pb-md-5">
					<div className="fw_600">
						<h3>Welcome back</h3>
					</div>
					<div className="dark-grey">
						<T>Login with your email and your password</T>
					</div>
				</div>
				<form onSubmit={(e) => e.preventDefault()} className="w-100 pb-5">
					<Input
						rounded
						dataCy="username"
						initValue={user.username}
            id={"username"}
						placeholder={<T>Username</T>}
						autofocus={true}
						type="username"
						className="w-100 mt-3 border_radius_6px"
						onChange={(username) => setUser({ ...user, username: username })}
					/>
					<Input
						rounded
						className="w-100 mt-3 border_radius_6px"
						dataCy="password"
            id={"password"}
						placeholder={<T>Password</T>}
						type="password"
						onChange={(password) => setUser({ ...user, password: password })}
					/>
					<RememberForgot
						user={user}
						setUser={setUser}
						setForgotPw={setForgotPw}
					/>
					<button
						className="text-white font_15px btn btn_green w-100 mt-5"
						disabled={submit_button_disabled}
            id={"loginBtn"}
						onClick={(e) => {
							e.preventDefault();
							handleLogin();
						}}
					>
						<T>Sign&nbsp;in</T>
					</button>
				</form>
			</Col>
			<div></div>
		</div>
	);
};

export default Login;
